import { FaGift } from "react-icons/fa";
import { getDiscountPercentage, getFinalPrice } from "../utils/pricing";

export default function DiscountRibbon({ item, compact = false }) {
  const discount = getDiscountPercentage(item);
  const isFree = getFinalPrice(item) === 0;
  if ((!discount && !isFree) || item?.purchased) return null;

  if (!isFree) {
    return (
      <span className="pointer-events-none absolute left-0 top-0 z-10 h-[76px] w-[76px] bg-gradient-to-br from-[#ff4657] to-[#ed1747] [clip-path:polygon(0_0,100%_0,0_100%)]" aria-label={discount + "% off"}>
        <span className="absolute left-0 top-[17px] w-[62px] -rotate-45 text-center text-[19px] font-extrabold leading-none text-white">{discount}%</span>
      </span>
    );
  }

  return (
    <span className={"discount-ribbon-free pointer-events-none absolute left-0 top-4 z-10 isolate inline-flex origin-left items-center gap-1.5 overflow-hidden bg-[linear-gradient(115deg,#b7790b_0%,#f5c842_28%,#fff0a3_52%,#eab72e_78%,#c58a12_100%)] pl-4 pr-[26px] font-extrabold uppercase tracking-wide text-amber-950 shadow-[inset_0_1px_0_rgb(255_255_255/65%),inset_0_-2px_0_rgb(120_70_0/25%)] [clip-path:polygon(0_0,100%_0,calc(100%_-_10px)_50%,100%_100%,0_100%)] " + (compact ? "py-1 text-[10px]" : "py-2 text-xs")}>
      <span aria-hidden="true" className="discount-ribbon-shine absolute inset-0 -translate-x-[140%] bg-[linear-gradient(110deg,transparent_25%,rgb(255_255_255/12%)_40%,rgb(255_255_255/45%)_50%,rgb(255_255_255/12%)_60%,transparent_75%)]" />
      <FaGift aria-hidden="true" className="discount-ribbon-sparkle relative" />
      <span className="relative">Free</span>
    </span>
  );
}
